import { render, staticRenderFns } from "./RecentParcels.vue?vue&type=template&id=f2b65d86&scoped=true"
import script from "./RecentParcels.vue?vue&type=script&lang=ts"
export * from "./RecentParcels.vue?vue&type=script&lang=ts"
import style0 from "./RecentParcels.vue?vue&type=style&index=0&id=f2b65d86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b65d86",
  null
  
)

export default component.exports